import React from 'react';
import css from './PageTitle.module.css';
import classNames from 'classnames';
import { StringUtils } from '../../../utils/string';

export const PageTitle = ({ children, style = {}, center = false, className, autoCap = true }: any) => {
  return (
    <div style={style} className={classNames(css.container, center && css.center, className)}>
      {autoCap ? StringUtils.toFirstCapEachWord(children) : children}
    </div>
  );
};
